<template>
  <div>
    <el-row :gutter="24">
      <el-col :span="24">
        <p>
          <b>Основание владения автомобилем</b>
        </p>
        <ul class="list-none">
          <li>
            <el-radio v-model="reason" :label="1">
              Собственник (указан в СТС)
            </el-radio>
          </li>
          <li>
            <el-radio v-model="reason" :label="4">
              Договор аренды с собственником
            </el-radio>
          </li>
          <li>
            <el-radio v-model="reason" :label="2">
              Лизинг, в СТС указан собственник Лизинговая компания
            </el-radio>
          </li>
        </ul>
      </el-col>
    </el-row>
    <set-carrier
      v-if="reason"
      :auto="auto"
      :reason="reason"
      @changed="changed"
    />
  </div>
</template>

<script>
import { filesValidateMixinParentActions } from '@/mixins/filesValidateMixin'
import SetCarrier from './SetСarrier'

export default {
  name: 'CarrierReason',
  components: { SetCarrier },
  mixins: [filesValidateMixinParentActions],
  props: {
    auto: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      reason: 0,
      fileRefsList: ['rentFiles', 'leasingFiles'],
    }
  },
  watch: {
    reason(newVal) {
      this.setReason(newVal)
    },
  },
  methods: {
    setReason(reason) {
      this.$emit('set', reason)
    },
    changed(data) {
      // TODO валидация формы
      this.$emit('changed', data)
    },
  },
}
</script>

<style scoped lang="sass">
.list-none
    padding: 0
    li
        list-style-type: none
</style>
